import React from 'react'
import { ResetPasswordCard } from './ResetPasswordCard'
import { CardContainer } from '../../genericComponents/CardContainer'

//different modes call different api. This is done because user enabling and password resetting
//use same view and data structures but have different endpoints b
type Props = { mode: 'resetPassword' | 'enableUser' }

export const ResetPasswordPage: React.FC<Props> = (props) => {
  return (
    <div className="h-screen w-screen bg-login-art bg-cover md:pt-[10vh]">
      <CardContainer variant="flex" className="items-center justify-center">
        <ResetPasswordCard mode={props.mode} />
      </CardContainer>
    </div>
  )
}
